function assert(arg: any, message?: string): asserts arg {
	if (!arg) {
		throw new Error(message ? `Assertion failed: "${ message }"` : `Assertion failed`)
	}
}

export function assert_and_return<T>(arg: T) {
	assert(arg)
	return arg
}

export function assert_in(key: string | number | symbol, o: object, message?: string): asserts key is keyof typeof o {
	assert(key in o, message)
}

export default assert
